import Kernel from './Kernel';
import RequestHandler from '../library/RequestHandler';
import { setFormLocale } from '../utils/form';
import '../utils/loader';

const Request = new RequestHandler();

class Form extends Kernel {
    constructor (target, settings) {
        console.log('Super: Form has been loaded', target);

        super(target);

        // overwrite the this.$el else we get weird stuff in extended classes
        this.$form = this.$el;

        // overwrite the this.$el to a proper form
        if (this.$el.prop('tagName') !== 'FORM')
        {
            this.$form = this.$el.find('form');
        }

        this.formAction = this.$form.attr('action');

        if (typeof this.formAction === 'undefined')
        {
            throw new Error('Oops! No action attribute found on the form element.');
        }

        this.$btn = this.$form.find('button[type="submit"]');
        this.settings = $.extend({
            hasLoader: true,
        }, this.settings, settings);

        this.initForm();
    }

    /**
     * Ready up the form instance
     */
    initForm () {
        this.$form.formValidation().on('success.field.fv', (e, data) => {
            if (data.fv.getInvalidFields().length === 0)
            {
                data.fv.disableSubmitButtons(false);
            }
        }).on('success.form.fv', (e) => {
            e.preventDefault();

            this.beforeFormSend();

            Request.post(this.formAction, this.$form.serialize(), (result) => {
                this.successFormHandler(result);
            }, (error) => {
                this.errorFormHandler(error);
            });
        });

        setFormLocale(this.$form, 'nl_NL');
    }

    /**
     * Do something before we submit the form
     */
    beforeFormSend () {
        if (this.settings.hasLoader)
        {
            this.$btn.loader({ size: 30 });
        }
    }

    /**
     * Do something when the form is successfully
     * @param result
     */
    successFormHandler (result) {
        if (this.settings.redirect)
        {
            window.location(this.settings.redirect);
        }
        else if (this.settings.reload)
        {
            location.reload();
        }
        else if (result.html)
        {
            this.$form.parent().empty().html(result.html);
        }
        else
        {
            throw new Error('Oops! Please provide a valid action when form is successful.');
        }
    }

    /**
     * Do something when the form encountered an error
     * @param error
     */
    errorFormHandler (error) {
        const title = error.errorCode === 3 ? 'Warning' : 'Error';
        const message = error.errorCode === 3 ? error.message : error.errorMessage;

        if (this.settings.hasLoader)
        {
            this.$btn.loader('stop');
        }

        $.growl.error({ title, message });
    }

    /**
     * Destroy the form instance
     */
    destroyForm () {
        this.$form.destroy();
    }

    destroy () {
        console.log('%cModule: Form has been destroyed', 'color: red;');
        this.$el.off();
    }
}

export default Form;


// WEBPACK FOOTER //
// ./app/src/js/modules/Form.js